<div>
    <div class="modal-header">
        <button aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="handleModalHide()">
            <span aria-hidden="true"> × </span>
        </button>
    </div>
    <div class="modal-body">
        <div class="info">
            <h3>Subscription History</h3>
        </div>
        <form (ngSubmit)="onContinueEvent()">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="form-control-label" for="subscription-history">
                            Subscription History
                        </label>
                        <input type="text" id="subscription-history" name="subscription-history" [maxlength]="50"
                            [(ngModel)]="subscriptionHistory" class="input form-control" 
                            (blur)="displayErrorInSubscriptionHistory=false"
                            (input)="preventWhiteSpace($event)"
                            (keydown)="PreventWhiteSpaceAndNotifyWhenExceedMaxChars($event)"/>
                            <div *ngIf="displayErrorInSubscriptionHistory" class="input-errors">
                              <p >You can write up to 50 characters only</p>
                            </div>
                        </div>
                </div>
            </div>
            <div class="actions">
                <button class="btn action-btn back-btn" type="button" (click)="handleModalHide()">
                    Cancel
                </button>
                <button class="btn action-btn continue-btn" type="submit"
                    [disabled]="isSubmitDisabled()">
                    Submit
                </button>
            </div>
        </form>
    </div>
</div>